import type {MetadataOrder} from 'services/metadata/types';

export const getManifestationCountInWork = (
  expressionOrder: MetadataOrder,
): number => {
  return expressionOrder
    .map(g => g.content.filter(c => c.type === 'manifestation').length)
    .reduce((a, b) => a + b, 0);
};
